import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, AlertController, Events } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { Storage } from "@ionic/storage";

import { LoginPage } from "../pages/login/login";
import { HomePage } from "../pages/home/home";
import { MensagensPage } from "../pages/mensagens/mensagens";

import { TabsPage } from "../pages/tabs/tabs";

import { TranslateService } from "@ngx-translate/core";
import { TranslateModule } from "@ngx-translate/core";

/* Push */
import { Push, PushObject, PushOptions } from "@ionic-native/push";
import { ControlContainer } from "@angular/forms";
// import { Push, PushObject, PushOptions } from '../plugins/phonegap-plugin-push/www/browser';
import { ApiProvider } from "../providers/api/api";

@Component({
	templateUrl: "app.html",
})
export class MyApp {
	@ViewChild(Nav) nav: Nav;

	rootPage: any;

	pages: Array<{ title: string; component: any; classe: string }>;

	constructor(
		public  platform    : Platform,
		public  statusBar   : StatusBar,
		public  splashScreen: SplashScreen,
		private storage     : Storage,
		public  push        : Push,
		public  alertCtrl   : AlertController,
		public  events      : Events,
		public  translate   : TranslateService,
		private _api        : ApiProvider,
	) {
		this.initializeApp();
	}

	initializeApp() {
		console.log("📲 App is running");
		var env = this;
		// window.alert('hello world');
		this.platform.ready().then(() => {
			var checkWhatsapp = this.platform.getQueryParam("whatsapptoken");
			console.log("🔴 checkWhatsapp: ", checkWhatsapp);
			if (checkWhatsapp) {
				this.storage.set('whatsapp', 1);
			}



			this.storage.get("lng").then((lng) => {
				this.translate.setDefaultLang(lng);
				this.translate.use(lng);

				this.storage.get("id_cliente").then((val) => {
					// this.splashScreen.hide();

					if (val == null) {
						this.rootPage = LoginPage;
					} else {
						// this.rootPage = HomePage;
						this.rootPage = TabsPage;
					}
					// Inicializa o push
					// console.log('initPushNotification');
					// this.platform.ready().then(async () => { this.initPushNotification(); });
					//@ts-ignore
					const messaging = firebase.messaging();

					const env = this;
					var FCMtoken: any;

					// navigator.serviceWorker.register('/pwa/firebase-messaging-sw.js')
					// .then((registration) => {
					//   console.log('Service Work funcionou');
					//   messaging.useServiceWorker(registration);
					//   // Request permission and get token.....
					// });
					messaging
					.requestPermission()
					.then(function () {
						console.log("🔵 Temos permissão");
						messaging.usePublicVapidKey(
							"BB8vhUuhwDggNLSH-DXAPMdAfYOajwJj1K73_ExVbsu8l94_L6DKDLayv_9RsN43zYx-1bwwN6QmM_ZP5h5oeck"
						);
						return messaging.getToken();
					})
					.then(function (token) {
						FCMtoken = token;
						console.log('📲 salvando Token gerado no stogare > ', token);
						env.storage.set("tokenpush", token);
						//salva o push se o cliente estiver logado
						if (val != null) {
							let dadosT;
							if (env.platform.is("ios")) {
								dadosT = { token: token, id: val, platform: "ios" };
							} else {
								dadosT = { token: token, id: val, platform: "android" };
							}
							console.log('app.component salva push dados = ', dadosT);
							env._api.token(dadosT).subscribe((arg3) => { });
						}

						messaging.onMessage(function (payload) {
							console.log('[onMessage] > ', payload);

							let confirmAlert;
							confirmAlert = env.alertCtrl.create({
								title: payload.notification.title,
								message: payload.notification.body,
								buttons: [
									{
										text: "Ok",
										role: "cancel",
										handler: data => {
										    env.nav.setRoot(HomePage);
										}
									},
								],
							});
							confirmAlert.present();
							
							var notification = messaging.swRegistration.showNotification(
								payload.notification.title, {
									body: payload.notification.body,
									icon: 'https://www.cartaofidelidadedigital.com.br/pwa/icons/17d559f7-617c-d3f7-bea8-f0034db41fa6.webPlatform.png',
								}
							);
						});
					})
					.catch(function (err) {
						console.log(JSON.stringify(err));
						console.log('code',err.code);
						if(err.code == 20){
							env.storage.get("jarecarregueipage").then((jarecarregueipage) => {
								if(jarecarregueipage == null){
									env.storage.set("jarecarregueipage", 1);
									window.location.reload();
								}
							});
						}
					});
					// messaging.onMessage(function (payload) {
					// 	console.log('[onMessage] > ', payload);
					// 	var notification = new Notification(payload.notification.title, {
					// 		body: payload.notification.body,
					// 	});
					// });
				});
			});
		});
	}

	initPushNotification() {
		const options: PushOptions = {
			android: {
				sound: true,
				vibrate: true,
				icon: "push",
			},
			ios: {
				alert: true,
				badge: true,
				sound: true,
			},
			browser: {
				pushServiceURL: "http://push.api.phonegap.com/v1/push",
			},
		};
		const pushObject: PushObject = this.push.init(options);

		pushObject.on("registration").subscribe((data: any) => {
			// console.log("device token -> " + data.registrationId);
			this.storage.set("tokenpush", data.registrationId);
			// console.log("this.storage:", this.storage);
		});

		pushObject.on("notification").subscribe((data: any) => {
			this.storage.get("badge").then((val) => {
				if (val == null) this.storage.set("badge", 1);
				else this.storage.set("badge", val + 1);
			});

			console.log("message -> " + data.message);

			let idemp = data.additionalData.id_empresa;
			if (data.additionalData.foreground) {
				let confirmAlert;
				if (data.additionalData.tipo == "mensagem") {
					confirmAlert = this.alertCtrl.create({
						title: data.title,
						message: "",
						buttons: [
							{
								text: "Ver",
								role: "cancel",
								handler: (data) => {
									this.nav.setRoot(TabsPage, { tipo: "mensagem", id: idemp });
								},
							},
							{
								text: "Ver depois",
								role: "cancel",
							},
						],
					});
				} else {
					confirmAlert = this.alertCtrl.create({
						title: data.title,
						message: data.message,
						buttons: [
							{
								text: "Ok",
								role: "cancel",
								// handler: data => {
								//     this.nav.setRoot(HomePage);
								// }
							},
						],
					});
				}

				this.storage.get("viewMsg").then((viewMsg) => {
					if (viewMsg == 1) {
						this.storage.get("id_empresa_escolhida").then((val) => {
							if (val != idemp) {
								confirmAlert.present();
							}
						});
					} else {
						confirmAlert.present();
					}
				});
			} else {
				//if user NOT using app and push notification comes
				console.log("else");
				if (data.additionalData.tipo == "mensagem") {
					this.nav.setRoot(TabsPage, { tipo: "mensagem", id: idemp });
				} else {
					this.nav.setRoot(TabsPage);
				}
			}
		});

		pushObject
			.on("error")
			.subscribe((error) => console.error("Error with Push plugin" + error));

		this.events.subscribe("subs:novo", (topic) => {
			pushObject.subscribe(topic);
		});

	}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts